"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});


// eslint-disable-next-line import/prefer-default-export
var SIGNING_MODES = exports.SIGNING_MODES = {
  DEFAULT: 0,
  TREZOR: 1
};
//# sourceMappingURL=constants.js.map